<template>
	<div id="top" style="padding-top: 72px">
		<head-nav @userInfo="getUserToken"></head-nav>
		<div class="domConversionOfd_body" :class="isPhone == 'true' ? 'mobile' : ''">
			<div class="title">
				<span>{{ pageTitle }}
					<span class="icon_free">限时免费</span>
				</span>
			</div>
			<div class="s_title" v-html="pageStitle"></div>
			<div class="down-type" :class="{ active: isShow }">
				<uploader ref="uploader" :options="options" :autoStart="false" @file-added="onFileAdded"
					@dragenter="dragenter" @files-submitted="onSubmitted" class="uploader-app" v-if="!isShow">
					<uploader-unsupport></uploader-unsupport>
					<uploader-drop>
					<div class="uploader-btn btn btn-primary" v-if="!token"
						@click.prevent="loginBtn">选择文件</div>
					<uploader-btn id="global-uploader-btn" v-else class="uploader-btn btn btn-primary" :attrs="attrs"
						:single="pageType == 'toimg'" ref="uploadBtn">选择文件</uploader-btn>
					<p>点击或拖拽打开文件，文件总大小不超过10M。</p>
					<p style="padding-top: 8px" v-if="pageType == 'toimg'">仅支持单个文件转换</p>
					<!-- <div class="tips_box">
                        <div class="tips_upload">限时免费，开启OFD畅享体验</div>
                    </div> -->
				</uploader-drop>
				</uploader>
				<img-turn :isShowData="isShow" :isUploadImgData="isUploadImg" :fileListData="fileList"
					:attrsData="attrs.accept" :pageTypeData="pageType" :imgtoOfdAginData="imgtoOfdAgin"
					:originFileIdData="originFileId" @endTurn="endTurn" @AddUpload="AddUpload"
					:isMergeTurnData="isMergeTurn" :zhErrorData="zhError"></img-turn>
			</div>
			<!--   转换描述   -->
			<conversion-des :pageName="pageType"></conversion-des>
			<!-- 提示弹框 -->
			<el-dialog title="提示" :visible.sync="dialogFolder" class="changephone_box fail_box"
				:close-on-click-modal="false" width="420px" append-to-body>
				<div class="content">
					<h2>以下{{ gsErrorList.length + wkErrorList.length }}个文件添加失败！</h2>
					<div class="item_list" v-if="gsErrorList.length > 0">
						<h3>文件格式不匹配：</h3>
						<p v-for="(item, index) in gsErrorList" :key="index">
							<icon :type="1" :fileType="item.fileType" :isTable="true" :fileFail="false" :isSeach="true">
							</icon>
							<a :title="item.name + '.' + item.fileType">{{ item.name.length > 15 ? item.slname :
									item.name
							}}{{ "." + item.fileType }}</a>
						</p>
					</div>
					<!-- <div class="item_list" v-if="cfErrorList.length > 0">
                        <h3>文件已存在：</h3>
                        <p v-for="(item, index) in cfErrorList" :key="index">
                        {{ item.name }}
                        </p>
                    </div> -->
					<div class="item_list" v-if="wkErrorList.length > 0">
						<h3>文件大小为空：</h3>
						<p v-for="(item, index) in wkErrorList" :key="index">
							<img src="@comm/images/document-conversion/kong_icon.svg" />
							<a :title="item.name + '.' + item.fileType">{{ item.name.length > 15 ? item.slname :
									item.name
							}}{{ "." + item.fileType }}</a>
						</p>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submitFolder" size="mini">确 定</el-button>
				</div>
			</el-dialog>
		</div>
		<customer-service></customer-service>
		<!--    footer -->
		<footer-nav></footer-nav>
	</div>
</template>
 
<script>
import SparkMD5 from "spark-md5";
import domTurn from "@comm/components/document-conversion/domTurn";
import imgTurn from "@comm/components/document-conversion/imgTurn";
import { ACCEPT_CONFIG } from "@comm/utils/acceptFileType.js";
import { queryFileUploadInfo, uploadBurstFile, getImg, transferPoll } from "@comm/api/document-conversion";
import footerNav from "@comm/components/document-conversion/footerPage";
import headNav from "@comm/components/document-conversion/headerPage";
import conversionDes from "@comm/components/document-conversion/conversionDes";
import icon from "@comm/components/document-conversion/iconImg";
import customerService from "@comm/components/document-conversion/customerService";
import { buriedPoint } from "@comm/utils/buryingPoint.js";
import { getToken } from "@comm/utils/auth";
import common from "@comm/utils/common";
export default {
			metaInfo: {
    title: '数科OFD格式转换中心，支持OFD在线转换为PDF等多种格式',
    meta: [
      {
        name: 'keywords',
        content: 'OFD、PDF转换、OFD格式转换、OFD转换、OFD转换格式'
      },
      {
        name: 'description',
        content: '数科OFD在线格式转换中心，支持OFD文档转换成PDF、图片，以及PDF、Excel、Word、PPT等格式转换成OFD；支持文件批量转换、合并转换。'
      }
    ]
  },
	components: {
		imgTurn,
		domTurn,
		footerNav,
		conversionDes,
		icon,
		customerService,
		headNav
	},
	name: "index",
	data() {
		return {
			fileList: [],
			options: {
				target: "invoice-info/upload",
				chunkSize: "2048000",
				fileParameterName: "upfile",
				maxChunkRetries: 1,
				testChunks: false,
				allowDuplicateUploads: true,
				headers: {
					// Authorization: getToken(),
				},
				query() { }
			},
			attrs: {
				accept: ""
			},
			isShow: false,
			isUploadImg: false,
			pageType: "",
			pageTitle: "",
			pageStitle: "",
			imgtoOfdAgin: false,
			originFileId: {},
			turnCount: 0,
			newList: [],
			upTime: "",
			oldFileList: [],
			dialogFolder: false,
			gsErrorList: [],
			cfErrorList: [],
			wkErrorList: [],
			isMergeTurn: false,
			MergeData: null,
			zhError: false,
			resultList: [],
			isPhone: false,
			uploadList: [],
			uploadListLength: 0,
			token: getToken()
		};
	},
	created() {
		this.turnCount = localStorage.turnCount ? localStorage.turnCount : 0;
		let path = this.$route.query.type;
		if (path) {
			this.pageType = path;
		} else {
			this.pageType = "toimg";
		}
		if (this.pageType == "toimg") {
			this.pageTitle = "OFD/PDF转图片";
			this.pageStitle = "<p>支持将<span style='display:inline-block;width:8px'></span>OFD/PDF文档页面转换为图片格式</p>";
			this.attrs.accept = ACCEPT_CONFIG.getAllDomCon();
		} else {
			this.pageTitle = "图片转OFD/PDF";
			this.pageStitle = "<p>支持将<span style='display:inline-block;width:8px'></span>PNG、JPG、BMP、TIFF格式转换为OFD/PDF</p>";
			this.attrs.accept = ACCEPT_CONFIG.getImg();
		}
	},
	mounted() {
		this.isPhone = localStorage.getItem("isPhone");
		document.title = this.pageTitle;
		let toElement = document.getElementById("top");
		//锚点存在跳转
		toElement.scrollIntoView();
		document.body.ondrop = function(event){
			event.preventDefault();
			event.stopPropagation();
		}
	},

	watch: {
		$route(to, from) {
			this.$router.go(0);
		},
		uploadList(val) {
			if (val.length > 0 && this.isUploadImg) {
				for (let index = 0; index < val.length; index++) {
					if (index <= 4) {
						this.uploadApi(index);
					}
				}
			}
		},
		uploadListLength(val) {
			if (this.uploadListLength + 5 <= this.uploadList.length) {
				this.uploadApi(this.uploadListLength + 4);
			}
		}
	},
	methods: {
		getUserToken(data) {
			this.token = data.token
		},
		confirm(text, type) {
			this.$confirm(text, "", {
				confirmButtonText: "确定",
				showCancelButton: false,
				type: type,
			}).then(() => {
				return;
			});
		},
		dragenter() {
			this.isDragenter = true;
		},
		submitFolder() {
			this.dialogFolder = false;
			setInterval(function () {
				this.gsErrorList = [];
				// this.cfErrorList = [];
				this.wkErrorList = [];
			}, 300);
		},
		loginBtn() {
			let path = `${this.$route.path}?type=${this.$route.query.type}`;
			window.open(
				`https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
				"_self"
			);
		},
		onFileAdded(file, isReUpload, fileList) {
			if (this.pageType == "toimg") {
				this.attrs.accept = ACCEPT_CONFIG.getAllDomCon();
			} else {
				this.attrs.accept = ACCEPT_CONFIG.getImg();
			}
			this.gsErrorList = [];
			// this.cfErrorList = [];
			this.wkErrorList = [];
			file.wait = true;
			file.progress = 0;
			file.disable = true;
			let fileReader = new FileReader();
			fileReader.readAsDataURL(file.file);
			fileReader.onloadend = (e) => {
				file.url = e.target.result;
			};
			if (isReUpload) {
				this.fileList = fileList;
				this.uploadApi(file.index, isReUpload);
			}
		},
		onSubmitted(fileList) {
			this.uploadList = [];
			this.uploadListLength = 0;
			// if (this.turnCount >= 5) {
			//   this.$refs.uploader.uploader.cancel();
			//   this.$confirm("今日转换次数已达上限5次", "", {
			//     confirmButtonText: "确定",
			//     showCancelButton: false,
			//     type: "warning",
			//   }).then(() => {
			//     return;
			//   });
			//   return;
			// }
			// if (this.imgtoOfdAgin) {
			//       //  this.fileList = this.oldFileList;
			//       this.isShow = false;
			//     }
			if (fileList.length <= 0) {
				return;
			}
			if (this.pageType == "toimg" && fileList.length > 1) {
				this.confirm('该功能仅支持单文件操作', 'warning')
				return;
			}


			let dictionaryId = 0;
			if (this.pageType == "toimg") {
				dictionaryId = 101;
			} else {
				dictionaryId = 83;
			}
			let clickType = this.isDragenter ? 1 : 0;
			this.isDragenter = false;
			setTimeout(function () {
				buriedPoint("isUpload", dictionaryId, clickType);
			}, 200);
			let sizeTotal = 0;

			let isLt = false;
			let msg = "";
			// if(!this.MergeData){
			//   this.isShow=false
			// }

			this.isUploadImg = true;

			if (this.pageType == "toimg") {
				fileList.forEach((item) => {
					sizeTotal += +item.size;
				});
				isLt = sizeTotal / 1024 / 1024 / 10 <= 1;
				msg = "您选择的文件大小超过10M，请重新选择！";
			} else {
				let totalFileList = [];
				totalFileList = [...this.oldFileList, ...fileList];
				totalFileList.forEach((item) => {
					sizeTotal += +item.size;
				});
				isLt = sizeTotal / 1024 / 1024 / 10 <= 1;
				msg = "您选择的文件总大小超过10M，请重新选择！";
			}

			if (!isLt) {
				if (!this.zhError) {
					this.isUploadImg = false;
				}

				if (this.fileList.length > 0) {
					this.isShow = true;
				}
				if (this.MergeData) {
					this.isShow = true;
					this.isMergeTurn = true;
				} else {
					this.isMergeTurn = false;
				}
				this.$confirm(msg, "", {
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "warning",
					showClose: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					lockScroll: false,
					cancelButtonText: "取消"
				}).then(() => {
					if (this.imgtoOfdAgin) {
						//  this.fileList = this.oldFileList;
						if (this.fileList.length <= 0) {
							this.isShow = false;
						}
					}
					// this.$refs.uploader.uploader.cancel();
					return;
				});
			} else {
				this.isUploadImg = true;
				if (this.fileList.length <= 0) {
					this.isShow = false;
				}
				this.isMergeTurn = false;

				let index = 0;
				this.infoDetails(index, fileList);
			}
		},
		infoDetails(index, fileList) {
			let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
			let fileReader = new FileReader();
			let spark = new SparkMD5.ArrayBuffer();
			fileReader.readAsArrayBuffer(blobSlice.call(fileList[index].file, 0, fileList[index].size));
			// 开始读取文件内容

			// 读取操作结束时触发
			fileReader.onload = (e) => {
				fileList[index].fileHash = this.$sha256(e.target.result);
				spark.append(e.target.result);
				fileList[index].baseUrl = spark.end();
				if (index == fileList.length - 1) {
					let lng = 0;
					let okList = [];
					this.newList = [];
					fileList.forEach((item, indexs) => {
						this.newList.push(item);
						if (indexs == fileList.length - 1) {
							this.dealData(lng, okList, fileList);
						}
					});
				} else {
					index = index + 1;
					this.infoDetails(index, fileList);
				}
			};
		},
		dealData(lng, okList, fileList) {
			let file = this.newList[lng];
			let extName = "";
			let AllUpExt = "";
			if (this.pageType == "toimg") {
				AllUpExt = ".ofd|.pdf|";
			} else {
				AllUpExt = ".png|.jpg|.bmp|.tiff|.tif|";
			}
			extName = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
			if (AllUpExt.indexOf(extName + "|") == "-1") {
				file.cancel();
				var index = file.name.lastIndexOf(".");
				file.fileType = file.name.substring(index + 1, file.name.length);
				file.name = file.name.substring(0, index);
				let fileListArrayname = file.name;
				let fileNameSuffix1 = fileListArrayname;
				if (fileListArrayname.length > 15) {
					file.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
				}
				this.gsErrorList.push(file);
				fileList.splice(lng, 1);
				//this.isUploadImg = false;
			} else if (file.size == 0) {
				file.cancel();
				var index = file.name.lastIndexOf(".");
				file.fileType = file.name.substring(index + 1, file.name.length);
				file.name = file.name.substring(0, index);
				let fileListArrayname = file.name;
				let fileNameSuffix1 = fileListArrayname;
				if (fileListArrayname.length > 15) {
					file.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
				}
				this.wkErrorList.push(file);
				fileList.splice(lng, 1);
				//this.isUploadImg = false;
			} else {
				if (this.oldFileList.length > 0 && this.pageType != "toimg") {
					let nameLng = 1;
					let isReturn = false;

					for (var jj = 0; jj < this.oldFileList.length; jj++) {
						var list = this.oldFileList[jj];
						if (file.baseUrl == list.baseUrl && file.name == list.name + "." + list.fileType) {
							// this.$refs.uploader.uploader.cancel();
							isReturn = true;
							file.cancel();
							// this.cfErrorList.push(file);
							fileList.splice(lng, 1);
							// this.isUploadImg = false;
						} else if (file.name == list.name + "." + list.fileType && file.baseUrl != list.baseUrl) {
							let index = file.name.lastIndexOf(".");
							let fileNameSuffix = file.name.substring(0, index);
							let fileType = file.name.substring(index, file.name.length);
							var fileNameTmp = file.name.substring(0, index) + "(" + nameLng + ")";
							for (var i = 0; i < this.oldFileList.length; i++) {
								if (fileNameTmp == this.oldFileList[i].name) {
									fileNameTmp = fileNameSuffix + "(" + ++nameLng + ")";
									i = 0;
								}
							}
							file.name = fileNameTmp + fileType;
							okList.push(file);
							break;
						} else {
							if (this.oldFileList.length - 1 == jj && !isReturn) {
								okList.push(file);
								break;
							}
						}
					}
				} else {
					okList.push(file);
				}
			}
			if (lng != this.newList.length - 1) {
				lng = lng + 1;
				this.dealData(lng, okList, fileList);
			} else {
				if (this.gsErrorList.length > 0 || this.wkErrorList.length > 0) {
					if (this.pageType == 'toimg') {
						this.confirm(this.gsErrorList.length ? '添加失败，文件格式不匹配！' : '添加失败，文件大小为空！', 'error')
					} else {
						this.dialogFolder = true;
					}
				}
				if (okList.length <= 0) {
					if (this.fileList.length > 0 || this.resultList.length > 0) {
						this.isShow = true;
					}
					if (!this.zhError) {
						this.isUploadImg = false;
					}
					return;
				}
				this.fileList = [];
				okList.forEach((item) => {
					item.isUpLoading = true;
					item.wait = false;
					var index = item.name.lastIndexOf(".");
					item.fileType = item.name.substring(index + 1, item.name.length);
					item.name = item.name.substring(0, index);
				});
				this.fileList = okList;
				this.uploadList = okList;

				this.originFileId = {};
				this.isShow = true;
			}
		},
		uploadApi(i, isReUpload) {
			if (isReUpload) {
				this.isUploadImg = true;
			}

			this.zhError = false;
			let that = this;
			var fileListArray = {};
			fileListArray = that.fileList[i];

			let fileData = new FormData();
			let dictionaryId = 0;
			this.originFileId.fileType = fileListArray.fileType;
			//  this.originFileId.fileType=
			if (this.pageType == "toimg") {
				dictionaryId = 102;
			} else {
				dictionaryId = 84;
			}
			fileData.append("dictionaryId  ", dictionaryId);
			fileData.append("fileHash", this.fileList[i].fileHash);
			fileData.append("fileName  ", fileListArray.name + "." + fileListArray.fileType);
			// let endPro = 95;
			// that.upTime = setInterval(function () {
			//   if (fileListArray.progress < endPro) {
			//     fileListArray.progress++;
			//   }
			// }, 500);
			this.originFileId.name = fileListArray.name;
			let fileListArrayname = fileListArray.name;
			let fileNameSuffix1 = fileListArrayname;
			if (fileListArrayname.length > 15) {
				this.originFileId.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
			}
			queryFileUploadInfo({
				dictionaryId: 0,
				fileHash: fileListArray.fileHash,
				fileName: fileListArray.name + "." + fileListArray.fileType
			})
				.then((res) => {
					if (!res.data.fileConversionNeedDTO) {
						this.apiUpLoad(i, fileData, isReUpload);
					} else {
						this.uploadListLength = this.uploadListLength + 1;
						fileListArray.fileConversionNeedDTO = res.data.fileConversionNeedDTO;
						//  this.originFileId.fileType = fileType
						this.originFileId.fileConversionNeedDTO = res.data.fileConversionNeedDTO;
						if (this.pageType == "toimg") {
							this.getTransfer();
						} else {
							fileListArray.upLoadSuccess = true;
							// that.$set(that.fileList,i,fileListArray)
							if (this.uploadListLength == this.uploadList.length || isReUpload) {
								this.isUploadImg = false;
								return;
							}
						}
					}
				})
				.catch((err) => {
					this.apiUpLoad(i, fileData, isReUpload);
				});
		},
		apiUpLoad(i, fileData, isReUpload) {
			fileData.append("multipartFile ", this.fileList[i].file);
			if (this.pageType == "toimg") {
				fileData.append("type  ", 3);
			} else {
				fileData.append("type  ", 4);
			}
			uploadBurstFile(fileData)
				.then((res) => {
					this.fileList[i].isUpLoading = false;
					if (!res.data.success) {
						this.uploadListLength = this.uploadListLength + 1;
						this.fileList[i].upLoadSuccess = false;
						// fileListArray.upLoadError=true
						if (this.uploadListLength == this.uploadList.length || isReUpload) {
							if (this.pageType == "toimg") {
								this.originFileId.name = this.fileList[i].name;
								this.originFileId.fileType = this.fileList[i].fileType;
								this.zhError = true;
							} else {
								this.isUploadImg = false;
							}

							return;
						}
					}

					this.fileList[i].fileConversionNeedDTO = res.data.fileConversionNeedDTO;
					this.originFileId.fileConversionNeedDTO = this.fileList[i].fileConversionNeedDTO;
					this.originFileId.size = this.fileList[i].size;
					if (this.pageType == "toimg") {
						// this.isUploadImg = false;
						this.getTransfer();
					} else {
						this.uploadListLength = this.uploadListLength + 1;
						this.fileList[i].progress = 100;
						this.fileList[i].upLoadSuccess = true;
						if (this.uploadListLength == this.uploadList.length || isReUpload) {
							this.isUploadImg = false;
							return;
						}
					}
				})
				.catch((err) => {
					this.uploadListLength = this.uploadListLength + 1;
					this.fileList[i].upLoadSuccess = false;
					// fileListArray.upLoadError=true
					if (this.uploadListLength == this.uploadList.length || isReUpload) {
						if (this.pageType == "toimg") {
							this.originFileId.name = this.fileList[i].name;
							this.originFileId.fileType = this.fileList[i].fileType;
							this.zhError = true;
						} else {
							this.isUploadImg = false;
						}

						return;
					}
				});
		},
		getTransfer() {
			getImg({
				fileConversionNeedDTO: this.fileList[0].fileConversionNeedDTO,
				transferType: this.fileList[0].fileType.toLowerCase() == "ofd" ? 3 : 6
			}).then((res) => {
				if (!res.data) {
					return;
				}
				this.fileList[0].pollNum = 0
				let that = this;
				setTimeout(function () {
					that.getTransferPoll(res.data);
				}, 5000);
			});
		},
		//轮询
		getTransferPoll(data) {
			this.fileList[0].pollNum++
			let that = this;
			if (this.fileList[0].pollNum > 10) {
				this.fileList[0].pollNum=0
				if (this.pageType == "toimg") {
					this.zhError = true;
				} else {
					this.isUploadImg = false;
				}
				this.$message.error('网络异常，请重试！')
				return
			}

			// clearInterval(that.interval);
			transferPoll(data)
				.then((res) => {
					if (res.data.status == 1) {
						setTimeout(function () {
							that.getTransferPoll(data);
						}, 3000);
						// clearInterval(that.interval);
						// that.interval = setInterval(function () {
						//   that.getTransferPoll(data);
						// }, 3000);
					} else if (res.data.status == 0) {
						this.isUploadImg = false;
						localStorage.setItem("turnCount", res.data.count);
						this.turnCount = localStorage.turnCount;
						this.isShow = true;
						res.data.result.forEach((item, index) => {
							item.fileType = "jpg";
							item.index = index + 1;
							item.upLoadSuccess = true;
						});
						this.fileList = res.data.result;
						this.fileList[0].pollNum=0
						// clearInterval(that.interval);
						return;
					} else {
						this.fileList[0].pollNum=0
						if (this.pageType == "toimg") {
							this.zhError = true;
						} else {
							this.isUploadImg = false;
						}
					}
				})
				.catch((res) => {
					if (this.pageType == "toimg") {
						this.zhError = true;
					} else {
						this.isUploadImg = false;
					}
					// clearInterval(that.interval);
					// that.$message.error("转换失败");
				});
		},
		endTurn(data) {
			this.fileList = data.fileList;
			this.oldFileList = data.oldFileList ? data.oldFileList : this.oldFileList;
			this.isMergeTurn = data.isMergeTurn;
			this.MergeData = data.MergeData;
			this.isShow = data.isShow;
			this.originFileId = data.originFileId ? data.originFileId : {};
			this.resultList = data.resultList ? data.resultList : [];
		},
		AddUpload(data) {
			this.oldFileList = data.fileList;
			this.imgtoOfdAgin = data.imgtoOfdAgin;
			this.MergeData = data.MergeData;
			this.isMergeTurn = data.isMergeTurn;
			this.isShow = data.isShow;
		}
		// getPage(data) {
		//   this.fileList = data.fileList;
		//   this.pageType = data.pages;
		//   this.isShow = data.isShow;
		//   this.oldFileList = data.oldFileList;
		//   this.attrs.accept = ACCEPT_CONFIG.getImg();
		// },
		// contupLoadImg(data) {
		//   // this.fileList = data.fileList;
		//   this.isShow = false;
		//   this.imgtoOfdAgin = true;

		//   this.onSubmitted(data.fileList);
		// },
	}
};
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#top {
	background: #fff url(../../comm/images/document-conversion/bj.png) no-repeat top / 100% auto;
}
</style>


// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/imgConversion.vue